import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ModalLinkService {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly queryParamName = 'modalOpen';
  // TODO: Используется для обратной совместимости, после того как задача SPA-1942 выедет в прод, проверить что все ссылки поменяли и выпилить
  private readonly oldQueryParamName = 'cmsModalOpen';
  private readonly openedModalNameSubject = new ReplaySubject<string>(1);
  readonly openedModalName: Observable<string> = this.openedModalNameSubject.asObservable();

  triggerModal(modalName: string): void {
    this.router.navigate([], {
      queryParams: { [this.queryParamName]: modalName },
      replaceUrl: true,
    });
  }

  init(): void {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        startWith(null),
        map(() => {
          const urlTree = this.router.parseUrl(this.router.url);
          const params = urlTree.queryParams;

          return params[this.oldQueryParamName] || params[this.queryParamName];
        }),
        filter((modalName): modalName is string => typeof modalName === 'string' && modalName.length > 0),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((modalName) => {
        this.openedModalNameSubject.next(modalName);

        this.router.navigate([], {
          queryParams: {
            [this.queryParamName]: null,
            [this.oldQueryParamName]: null,
          },
          replaceUrl: true,
        });
      });
  }
}
